import {
  RESERVATION_TYPE_PREVIEW,
  RESERVATION_TYPE_NEW,
  RESERVATION_TYPE_UPDATE,
  RESERVATION_TYPE_REMOVE,
  RESERVATION_TYPE_PROCESS_SUCCESS,
  RESERVATION_TYPE_DATASOURCE_SUCCESS,
  RESERVATION_TYPE_SEARCH,
  RESERVATION_TYPE_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESERVATION_TYPE_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case RESERVATION_TYPE_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case RESERVATION_TYPE_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case RESERVATION_TYPE_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case RESERVATION_TYPE_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case RESERVATION_TYPE_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case RESERVATION_TYPE_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case RESERVATION_TYPE_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}